(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (() => {
    const el = document.querySelector('.shopify-section--announcement-bar');
    if (!el) return;
    const set = () => document.documentElement.style.setProperty('--announcement-bar-height', `${Math.round(el.clientHeight)}px`);
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(el);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    if (drawer.dataset.cartDrawerEvents === 'true') return;
    drawer.dataset.cartDrawerEvents = 'true';
    const panel = document.getElementById('cart-drawer-payment-panel');

    const ensurePanelInDrawer = () => {
      if (panel && !drawer.contains(panel)) {
        drawer.prepend(panel);
      }
    };

    ensurePanelInDrawer();
    document.addEventListener('shopify:section:load', ensurePanelInDrawer);

    const openPaymentPanel = () => {
      ensurePanelInDrawer();
      if (panel) panel.hidden = false;
    };

    drawer.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-payment-panel-close]')) {
        if (panel) panel.hidden = true;
      }
    });

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-origin="more-payments"]');
      if (!trigger || trigger.getAttribute('aria-controls') !== 'cart-drawer') return;
      openPaymentPanel();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const el = document.querySelector('.shopify-section--header');
    if (!el) return;
    const set = () => document.documentElement.style.setProperty('--header-height', `${Math.round(el.clientHeight)}px`);
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(el);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium_carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-thc-carousel]').forEach((carouselEl) => {
    const root = carouselEl.closest('.shopify-section');
    if (!root || root.dataset.premiumCarouselReady === 'true') return;
    root.dataset.premiumCarouselReady = 'true';

    const defaultColumns = carouselEl.dataset.defaultColumns || '4';
    const tabs = [...root.querySelectorAll('.thc-nav-btn')];
    const panels = [...root.querySelectorAll('.thc-products-container')];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const boundGrids = new WeakSet();

    const getLayout = (grid) => {
      const items = [...grid.querySelectorAll('.thc-item')];
      const columns = Number.parseInt(grid.dataset.columns, 10) || Number.parseInt(defaultColumns, 10) || 4;
      const mobile = window.matchMedia('(max-width: 989px)').matches;
      return { items, itemsPerPage: mobile ? 2 : columns, mobile };
    };

    const updateActiveDot = (panel) => {
      const grid = panel.querySelector('.thc-products');
      const dots = [...panel.querySelectorAll('.thc-dot')];
      if (!grid || dots.length === 0) return;
      const { items, itemsPerPage } = getLayout(grid);
      if (items.length === 0) return;
      const targetIndex = items.reduce((best, item, index) => {
        const distance = Math.abs(item.offsetLeft - grid.scrollLeft);
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
      const currentPage = Math.min(dots.length - 1, Math.floor(targetIndex / itemsPerPage));
      dots.forEach((dot, index) => {
        const active = index === currentPage;
        dot.classList.toggle('active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    const bindGridScroll = (panel) => {
      const grid = panel.querySelector('.thc-products');
      if (!grid || boundGrids.has(grid)) return;
      boundGrids.add(grid);
      let frame = 0;
      grid.addEventListener('scroll', () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = 0;
          updateActiveDot(panel);
        });
      }, { passive: true });
    };

    const renderDots = (panel) => {
      const grid = panel.querySelector('.thc-products');
      const dotsWrap = panel.querySelector('.thc-dots');
      if (!grid || !dotsWrap) return;
      const { items, itemsPerPage, mobile } = getLayout(grid);
      const totalPages = Math.ceil(items.length / itemsPerPage);
      dotsWrap.replaceChildren();
      if (totalPages <= 1) return;
      for (let page = 0; page < totalPages; page += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = `thc-dot${page === 0 ? ' active' : ''}`;
        dot.setAttribute('aria-label', `Ir para página ${page + 1} de ${totalPages}`);
        dot.setAttribute('aria-current', page === 0 ? 'true' : 'false');
        dot.addEventListener('click', () => {
          const target = items[page * itemsPerPage];
          if (!target) return;
          grid.scrollTo({ left: target.offsetLeft - (mobile ? 20 : 0), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        });
        dotsWrap.appendChild(dot);
      }
      bindGridScroll(panel);
      updateActiveDot(panel);
    };

    const hydratePanel = async (panel) => {
      if (!panel || panel.dataset.thcDeferred !== 'true' || panel.dataset.thcLoading === 'true') return;
      const handle = panel.dataset.collection;
      if (!handle) {
        delete panel.dataset.thcDeferred;
        return;
      }
      panel.dataset.thcLoading = 'true';
      try {
        const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const url = `${shopRoot}collections/${encodeURIComponent(handle)}?sections=thc-products-panel`;
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('section request failed');
        const payload = await response.json();
        const html = payload['thc-products-panel'];
        if (!html) throw new Error('section empty');
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const products = doc.querySelector('.thc-products');
        const dots = panel.querySelector(':scope > .thc-dots');
        if (products) {
          products.setAttribute('data-columns', panel.dataset.columns || defaultColumns);
          panel.insertBefore(products, dots || null);
        }
        delete panel.dataset.thcDeferred;
      } catch (error) {
        console.warn('[premium-carousel] deferred tab', error);
      } finally {
        delete panel.dataset.thcLoading;
      }
    };

    const activate = async (index) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.index === index;
        tab.classList.toggle('active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      for (const panel of panels) {
        const active = panel.dataset.index === index;
        if (active) await hydratePanel(panel);
        panel.classList.toggle('active', active);
        panel.hidden = !active;
        if (active) requestAnimationFrame(() => renderDots(panel));
      }
    };

    tabs.forEach((tab) => tab.addEventListener('click', () => activate(tab.dataset.index)));

    const initialPanel = panels.find((panel) => !panel.hidden) || panels[0];
    if (initialPanel) renderDots(initialPanel);

    let resizeFrame = 0;
    window.addEventListener('resize', () => {
      if (resizeFrame) return;
      resizeFrame = requestAnimationFrame(() => {
        resizeFrame = 0;
        const activePanel = panels.find((panel) => !panel.hidden) || panels[0];
        if (activePanel) renderDots(activePanel);
      });
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();
})();
